export default __webpack_public_path__ + "images/fa84f21bc7895912fe3994fbb9c73dca.svg";